import React from 'react';
import { Button } from 'antd';
import { Flow } from '../../../types/flow';

export const getClassificationTableColumns = (
  onClick: (inference: Flow) => any,
  onDelete: (e: any, inference: Flow) => any
) => {
  return [
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'name',
      render: (text: string, record: Flow) => (
        <Button type="link" style={{ color: '#1585FF' }} onClick={() => onClick(record)}>
          {text}
        </Button>
      ),
    },
    {
      title: 'Model',
      key: 'model',
      dataIndex: 'model',
      render: (text: string, record: Flow) => <span>{record.model.name}</span>,
    },
    {
      title: 'Classes',
      key: 'classes',
      render: (text: string, record: Flow) => {
        return (
          <span>
            {record.model.info && record.model.info.annotationTypes ? record.model.info.annotationTypes.length : 0}
          </span>
        );
      },
    },
    {
      title: 'Rules',
      key: 'rules',
      dataIndex: 'rules',
      render: (text: string, record: Flow) => {
        return <span>{Object.values(record.rules).reduce((prev, val) => prev + val.length, 0)}</span>;
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text: string, record: Flow) => (
        <span>
          <Button type="link" style={{ fontSize: '14px' }} onClick={e => onDelete(e, record)}>
            Delete
          </Button>
        </span>
      ),
    },
  ];
};
